module.exports = __webpack_public_path__ + "img/lichtgestalten3.e8537214.png";